export const GoogleAds = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="22"
    viewBox="0 0 24 22"
    fill="none"
    stroke="none"
  >
    <path
      d="M8.16715 3.14422C8.39912 2.56108 8.71808 2.02422 9.19169 1.58918C11.0861 -0.178749 14.2178 0.265548 15.5033 2.48703C16.4698 4.17166 17.4944 5.81926 18.4899 7.48537C20.1524 10.253 21.8342 13.0206 23.4773 15.7974C24.8595 18.1207 23.3613 21.0549 20.6163 21.4529C18.9345 21.6936 17.3591 20.9531 16.4892 19.5091C15.0297 17.0748 13.5605 14.6404 12.101 12.2153C12.072 12.1597 12.0334 12.1135 11.9947 12.0672C11.84 11.9468 11.7724 11.771 11.6757 11.6136C11.0281 10.5214 10.3612 9.43842 9.71363 8.35545C9.29801 7.65198 8.86306 6.95777 8.44745 6.2543C8.07049 5.62488 7.89651 4.93992 7.91584 4.21794C7.94484 3.84769 7.99317 3.47744 8.16715 3.14422Z"
      fill="#3C8BD9"
    />
    <path
      d="M8.16715 3.14422C8.08016 3.47744 8.00283 3.81067 7.9835 4.1624C7.9545 4.93992 8.15748 5.6619 8.56343 6.3376C9.62664 8.08702 10.6898 9.8457 11.7434 11.6044C11.84 11.7617 11.9174 11.9191 12.014 12.0672C11.4341 13.0298 10.8542 13.9832 10.2646 14.9459C9.45266 16.288 8.64076 17.6394 7.81919 18.9815C7.78053 18.9815 7.77086 18.963 7.76119 18.9353C7.75153 18.8612 7.78053 18.7964 7.79986 18.7224C8.19614 17.3339 7.86751 16.1029 6.87197 15.0477C6.26304 14.409 5.4898 14.048 4.60057 13.9277C3.44071 13.7703 2.41616 14.0573 1.49794 14.7515C1.33363 14.8718 1.22731 15.0477 1.034 15.1402C0.995334 15.1402 0.976003 15.1217 0.966337 15.094C1.43028 14.3257 1.88456 13.5574 2.34851 12.7892C4.26228 9.60503 6.17605 6.42091 8.09949 3.24604C8.11882 3.20901 8.14781 3.18124 8.16715 3.14422Z"
      fill="#FABC04"
    />
    <path
      d="M1.005 15.1217C1.18864 14.9644 1.36262 14.7978 1.55593 14.6497C3.90465 12.8725 7.43257 14.1591 7.94484 16.973C8.07049 17.6487 8.00283 18.2966 7.79019 18.9445C7.78053 19.0001 7.77086 19.0463 7.75153 19.1019C7.66454 19.25 7.58721 19.4073 7.49056 19.5554C6.63033 20.9161 5.36415 21.5918 3.70168 21.49C1.79757 21.3604 0.299417 19.9905 0.0384481 18.1763C-0.0872036 17.2969 0.0964412 16.4731 0.570051 15.7141C0.666707 15.5475 0.782693 15.3994 0.889013 15.2328C0.937341 15.1958 0.91801 15.1217 1.005 15.1217Z"
      fill="#34A852"
    />
    <path
      d="M1.005 15.1217C0.966337 15.1587 0.966337 15.2235 0.898679 15.2328C0.889013 15.168 0.927675 15.131 0.966337 15.0847L1.005 15.1217Z"
      fill="#FABC04"
    />
    <path
      d="M7.75153 19.1019C7.71287 19.0371 7.75153 18.9908 7.79019 18.9445C7.79986 18.9538 7.81919 18.9723 7.82885 18.9815L7.75153 19.1019Z"
      fill="#E1C025"
    />
  </svg>
);
